import "./poster-builder.7ec0a949.js";
import "./poster-builder.b2a72de8.js";
import "./poster-builder.40ac639a.js";
import "./poster-builder.020d19e0.js";
import "./poster-builder.cc8ec761.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2835"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2835"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Import components
parcelRequire("1enj3");
parcelRequire("eBwC4");
parcelRequire("ekXg5");
parcelRequire("9hC2G");
parcelRequire("3skPo");
parcelRequire("fzSrD");

var $7JB23 = parcelRequire("7JB23");
parcelRequire("3MUFr");


var $avtRj = parcelRequire("avtRj");

var $fmRoT = parcelRequire("fmRoT");

var $6KOho = parcelRequire("6KOho");

var $k4QTz = parcelRequire("k4QTz");
var $cbb38b46c9e48450$exports = {};
$cbb38b46c9e48450$exports = JSON.parse('{"age-groups":[{"Elite":[{"group":"16-24"},{"group":"25-29"},{"group":"30-34"},{"group":"35-39"},{"group":"40-44"}],"Open":[{"group":"16-24"},{"group":"25-29"},{"group":"30-34"},{"group":"35-39"},{"group":"40-44"},{"group":"45-49"},{"group":"50-54"},{"group":"55-59"},{"group":"60-64"},{"group":"65-69"},{"group":"70-74"},{"group":"75-79"},{"group":"80-84"},{"group":"85-89"}],"Pro":[{"group":"16-24"},{"group":"25-29"},{"group":"30-34"},{"group":"35-39"},{"group":"40-44"},{"group":"45-49"},{"group":"50-54"},{"group":"55-59"},{"group":"60-64"},{"group":"65-69"},{"group":"70-74"}],"Doubles":[{"group":"16-24"},{"group":"25-29"},{"group":"30-34"},{"group":"35-39"},{"group":"40-44"},{"group":"45-49"},{"group":"50-54"},{"group":"55-59"},{"group":"60-64"},{"group":"65-69"},{"group":"70-74"},{"group":"75-79"},{"group":"80-84"},{"group":"85-89"}],"Pro-Doubles":[{"group":"16-24"},{"group":"25-29"},{"group":"30-34"},{"group":"35-39"},{"group":"40-44"},{"group":"45-49"},{"group":"50-54"},{"group":"55-59"},{"group":"60-64"},{"group":"65-69"},{"group":"70-74"}],"Team Relay":[{"group":"U40"},{"group":"40+"}],"Adaptive":[{"group":"16-24"},{"group":"25-29"},{"group":"30-34"},{"group":"35-39"},{"group":"40-44"},{"group":"45-49"},{"group":"50-54"},{"group":"55-59"},{"group":"60-64"},{"group":"65-69"},{"group":"70-74"}]}],"divisions":[{"division":"Elite"},{"division":"Open"},{"division":"Pro"},{"division":"Doubles"},{"division":"Pro-Doubles"},{"division":"Team Relay"},{"division":"Adaptive"}],"events":[{"id":0,"location":"Heerenveen","short":"HEE","date":"14-17 mei 2026","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-heerenveen.webp?updatedAt=1741607029112","timestamp":"1778736864"},{"id":1,"location":"Rotterdam","short":"ROT","date":"15-19 april 2026","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-rotterdam-preview.webp","timestamp":"1776231264"},{"id":2,"location":"Valencia","short":"VLC","date":"8-9 maart 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-valencia.webp","timestamp":"1741443516"},{"id":3,"location":"Glasgow","short":"GLA","date":"13-16 maart 2025","imgUrl":"https://hyroxnetherlands.com/wp-content/uploads/2023/10/HYROX-Glasgow-scaled-1-1280x697.jpg","timestamp":"1741875516"},{"id":4,"location":"Kopenhagen","short":"CPH","date":"14-15 maart 2025","imgUrl":"https://hyroxnetherlands.com/wp-content/uploads/2023/10/hyrox-copenhagen.jpg","timestamp":"1741961916"},{"id":5,"location":"M\xe1laga","short":"MLG","date":"16-19 april 2025","imgUrl":"https://hyroxnetherlands.com/wp-content/uploads/2023/10/MLG-1-1.jpg","timestamp":"1776317664"},{"id":6,"location":"Belgi\xeb","short":"BEL","date":"5-6 april 2025","imgUrl":"https://hyroxnetherlands.com/wp-content/uploads/2024/07/Mechelen_zwart-wit-1280x854.jpeg","timestamp":"1743862716"},{"id":7,"location":"Keulen","short":"CGN","date":"16-19 april 2026","imgUrl":"https://hyroxnetherlands.com/wp-content/uploads/2024/11/af38a0d3-23a3-4995-a054-fa55c8526537-1280x854.jpg","timestamp":"1776317664"},{"id":8,"location":"Amsterdam","short":"AMS","date":"10-13 oktober 2024","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-amsterdam.jpg","timestamp":"1728569916"},{"id":9,"location":"Maastricht","short":"MAA","date":"1-2 februari 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-maastricht.jpg","timestamp":"1728569916"},{"id":10,"location":"Parijs","short":"PAR","date":"23-27 april 2026","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-paris.jpg","timestamp":"1776922464"},{"id":11,"location":"Barcelona","short":"BCN","date":"14-17 mei 2026","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-barcelona.jpg","timestamp":"1778736864"},{"id":12,"location":"London","short":"LON","date":"3-5 mei 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-london.jpg","timestamp":"1746344242"},{"id":13,"location":"Berlijn","short":"BER","date":"22-31 mei 2026","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-berlin.jpg","timestamp":"1779428064"},{"id":14,"location":"Maastricht","short":"MAA","date":"19-21 september 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-maastricht.jpg","timestamp":"1758267167"},{"id":15,"location":"Utrecht","short":"UTR","date":"28-30 november 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-utrecht-placeholder.webp","timestamp":"1764319471"},{"id":16,"location":"Stuttgart","short":"STR","date":"31 oktober - 2 november 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-stuttgart-placeholder.webp","timestamp":"1761900271"},{"id":17,"location":"Parijs","short":"PAR","date":"22-26 oktober 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-parijs-placeholder.webp","timestamp":"1761122671"},{"id":18,"location":"London","short":"LON","date":"4-7 december 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-london-placeholder.webp","timestamp":"1764837871"},{"id":19,"location":"Frankfurt","short":"FRA","date":"12-14 december 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-frankfurt-placeholder.webp","timestamp":"1765529071"},{"id":20,"location":"Gent","short":"GNT","date":"12-14 december 2025","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-gent-placeholder.webp","timestamp":"1765529071"},{"id":21,"location":"Amsterdam","short":"AMS","date":"21-25 januari 2026","imgUrl":"https://ik.imagekit.io/wallable/Hyrox-events/hyrox-amsterdam.jpg","timestamp":"1768981896"},{"id":22,"location":"Turijn","short":"TRN","date":"30 jan - 1 feb 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2023/09/Turin-1-1280x852.jpg","timestamp":"1769759496"},{"id":23,"location":"Wenen","short":"VIE","date":"6-8 februari 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2025/07/Vienna_Titelpic.png","timestamp":"1770364296"},{"id":24,"location":"Bilbao","short":"BLB","date":"7-8 februari 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2023/10/BLB-1-1280x851.jpg","timestamp":"1770364296"},{"id":25,"location":"Istanbul","short":"IST","date":"13-14 februari 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2025/07/Istanbul-6-2-1280x721.jpg","timestamp":"1770364296"},{"id":26,"location":"Kopenhagen","short":"CPH","date":"13-15 maart 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2025/07/WebP-Image.jpg","timestamp":"1773388296"},{"id":27,"location":"London","short":"LON","date":"24-29 maart 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2025/07/OLY.jpg","timestamp":"1774338696"},{"id":28,"location":"Mechelen","short":"MEC","date":"26-29 maart 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2024/07/Mechelen_zwart-wit-1280x854.jpeg","timestamp":"1774338696"},{"id":29,"location":"Helsinki","short":"HEL","date":"9-10 mei 2026","imgUrl":"https://hyrox.com/wp-content/uploads/2025/07/hyrox-helsinki-1280x720.png","timestamp":"1778316950"}]}');



var $8UUYp = parcelRequire("8UUYp");

var $47G0t = parcelRequire("47G0t");

var $6Kc1e = parcelRequire("6Kc1e");

var $gF0Ex = parcelRequire("gF0Ex");
class $e2b032b92297a643$export$c019608e5b5bb4cb {
    _schema = {};
    _query = {
        size: "posterSize",
        frame: "posterFrame",
        giftwrap: "posterGiftwrapSelect",
        ContestantName: "ContestantName",
        HyroxLocation: "HyroxLocation",
        HyroxShort: "HyroxShort",
        HyroxDivision: "HyroxDivision",
        HyroxAgeGroup: "HyroxAgeGroup",
        HyroxDate: "HyroxDate",
        HyroxFinishTime: "HyroxFinishTime",
        HyroxImg: "HyroxImg",
        printType: "PrintType",
        aluminiumColor: "AluminiumColor",
        PosterColorNumber: "SongPosterColorNumber",
        previousCartItemId: "previousCartItemId"
    };
    _options = {
        settingsPanel: "map",
        posterSize: "small",
        posterFrame: "black",
        acrylBlock: "no-block"
    };
    constructor(){
        this._searchParams = new URLSearchParams(window.location.search);
        // Flips the queries key and value
        this._queryMap = Object.assign({}, ...Object.entries(this._query).map(([a, b])=>({
                [b]: a
            })));
    }
    checkEncodeURI(str) {
        return /\%/i.test(str);
    }
    get(key, defaultValue = null, defaultType = null) {
        let type = this._schema[key] || defaultType;
        let value = this._getOption(key) || defaultValue;
        if (!type) return value || defaultValue;
        if (type === "object" && value) {
            if (this.checkEncodeURI(value)) value = decodeURI(value);
            return JSON.parse(value);
        }
        if (type === "split" && value) return value.replace("[", "").replace("]", "").split(",");
        if (type === "bool") {
            if (value === "true" || value === "1" || value === true) return true;
            if (value === "false" || value === "0" || value === false) return false;
            return this._options[key];
        }
        return value;
    }
    _getOption(key) {
        let value;
        let altKey = this._queryMap[key];
        // Try GET parameters
        value = this._searchParams.get(key);
        if (value !== null) return value;
        // Try GET parameters with custom name
        value = this._searchParams.get(altKey);
        if (value !== null) return value;
        // Try Local storage
        value = localStorage.getItem(key);
        if (value !== null) return value;
        // Return default value
        return this._options[key] || this._options[altKey];
    }
    _getQuery() {}
    all() {
        return this._options;
    }
}



var $1OR0H = parcelRequire("1OR0H");

var $5t1He = parcelRequire("5t1He");

var $gtTze = parcelRequire("gtTze");

var $6ZWSX = parcelRequire("6ZWSX");
var $b18d7d2eab6a6ad8$require$Buffer = $6ZWSX.Buffer;
let $b18d7d2eab6a6ad8$var$woocommerceUrl = "https://wallable.nl";
const $b18d7d2eab6a6ad8$var$apiBase = "";
let $b18d7d2eab6a6ad8$var$marketContext;
let $b18d7d2eab6a6ad8$var$t = (key)=>key;
let $b18d7d2eab6a6ad8$var$formatCurrency = (value)=>`\u{20AC}${Number(value).toFixed(2).replace(".", ",")}`;
let $b18d7d2eab6a6ad8$var$formatDate = (value)=>String(value);
const $b18d7d2eab6a6ad8$var$i18nReady = (0, $5t1He.initializeI18n)().then((i18n)=>{
    ({ marketContext: $b18d7d2eab6a6ad8$var$marketContext, t: $b18d7d2eab6a6ad8$var$t, formatCurrency: $b18d7d2eab6a6ad8$var$formatCurrency, formatDate: $b18d7d2eab6a6ad8$var$formatDate } = i18n);
    $b18d7d2eab6a6ad8$var$woocommerceUrl = $b18d7d2eab6a6ad8$var$marketContext.services.woocommerceBaseUrl;
    $b18d7d2eab6a6ad8$var$getSavedPoster();
    $b18d7d2eab6a6ad8$var$getEventFromQuery();
    $b18d7d2eab6a6ad8$var$toggleProductionEnv();
    $b18d7d2eab6a6ad8$var$calculatePosterPrice();
    $b18d7d2eab6a6ad8$var$resizePosterWrapper();
    $b18d7d2eab6a6ad8$var$toggleClearIcons();
    $b18d7d2eab6a6ad8$var$setPreviewMode();
});
const $b18d7d2eab6a6ad8$var$options = new (0, $e2b032b92297a643$export$c019608e5b5bb4cb)();
let $b18d7d2eab6a6ad8$var$PosterPreviewImage, $b18d7d2eab6a6ad8$var$EventsModal, $b18d7d2eab6a6ad8$var$cropper, $b18d7d2eab6a6ad8$var$HyroxImgUrl, $b18d7d2eab6a6ad8$var$HyroxImg, $b18d7d2eab6a6ad8$var$AgeGroup, $b18d7d2eab6a6ad8$var$Division;
let $b18d7d2eab6a6ad8$var$ShowMobileSettingPanel = false;
const $b18d7d2eab6a6ad8$var$BuilderName = $6KOho("body").attr("id");
let $b18d7d2eab6a6ad8$var$EventsInitialized = false;
let $b18d7d2eab6a6ad8$var$PrintTypeSelected = true;
let $b18d7d2eab6a6ad8$var$SettingsPanel = $b18d7d2eab6a6ad8$var$options.get("settingsPanel", "map");
let $b18d7d2eab6a6ad8$var$PosterSize = $b18d7d2eab6a6ad8$var$options.get("posterSize", "small");
let $b18d7d2eab6a6ad8$var$PosterFrame = $b18d7d2eab6a6ad8$var$options.get("posterFrame", "black");
let $b18d7d2eab6a6ad8$var$AcrylBlock = $b18d7d2eab6a6ad8$var$options.get("acrylBlock", "black");
let $b18d7d2eab6a6ad8$var$AluminiumColor = $b18d7d2eab6a6ad8$var$options.get("aluminiumColor", "silver");
let $b18d7d2eab6a6ad8$var$PrintType = $b18d7d2eab6a6ad8$var$options.get("printType", "paper");
let $b18d7d2eab6a6ad8$var$GiftCardText = "";
const $b18d7d2eab6a6ad8$var$ContestantNameInput = $6KOho("#contestant-name-input");
const $b18d7d2eab6a6ad8$var$ContestantNameLabel = $6KOho(".labels .contestant-name");
const $b18d7d2eab6a6ad8$var$LocationInput = $6KOho("#location-input");
const $b18d7d2eab6a6ad8$var$LocationLabel = $6KOho(".js-location");
const $b18d7d2eab6a6ad8$var$ShortInput = $6KOho("#short-input");
const $b18d7d2eab6a6ad8$var$ShortLabel = $6KOho(".js-short");
const $b18d7d2eab6a6ad8$var$DivisionsSelector = $6KOho(".js-division-select");
const $b18d7d2eab6a6ad8$var$DivisionLabel = $6KOho(".js-division");
const $b18d7d2eab6a6ad8$var$AgeGroupSelector = $6KOho(".js-age-group-select");
const $b18d7d2eab6a6ad8$var$AgeGroupLabel = $6KOho(".js-age-group");
const $b18d7d2eab6a6ad8$var$DateInput = $6KOho("#date-input");
const $b18d7d2eab6a6ad8$var$DateLabel = $6KOho(".js-date");
const $b18d7d2eab6a6ad8$var$FinishTimeInput = $6KOho("#finish-time-input");
const $b18d7d2eab6a6ad8$var$FinishTimeLabel = $6KOho(".js-finish-time");
const $b18d7d2eab6a6ad8$var$PosterWrapper = $6KOho(".map-wrapper");
const $b18d7d2eab6a6ad8$var$PosterSizeSelect = $6KOho(".js-poster-size");
const $b18d7d2eab6a6ad8$var$PosterFrameSelect = $6KOho(".js-poster-frame");
const $b18d7d2eab6a6ad8$var$AcrylBlockSelect = $6KOho(".js-acryl-block");
const $b18d7d2eab6a6ad8$var$PrintTypeSelect = $6KOho(".js-print-type");
const $b18d7d2eab6a6ad8$var$PosterGiftwrapSelect = $6KOho(".js-giftwrap");
const $b18d7d2eab6a6ad8$var$GiftCardSelect = $6KOho(".js-giftcard");
const $b18d7d2eab6a6ad8$var$ImageWrapper = $6KOho(".hyrox-image");
const $b18d7d2eab6a6ad8$var$eventsList = $6KOho(".js-events-list");
const $b18d7d2eab6a6ad8$var$CropImage = document.getElementById("crop-image");
const $b18d7d2eab6a6ad8$var$savePosterButton = $6KOho(".js-save-poster");
const $b18d7d2eab6a6ad8$var$debugReporter = (0, $1OR0H.DebugReporter)({
    ajaxUrl: $b18d7d2eab6a6ad8$var$apiBase + "/wp-json/wallable/v1/client-diagnostics",
    containerSelector: ".js-notifications",
    shouldShow: ({ meta: meta })=>meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
    extraContext: ()=>({
            builder: $6KOho("body").attr("id")
        })
}).init();
// For dismissing panel if previewing from shopping cart
function $b18d7d2eab6a6ad8$var$setPreviewMode() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("preview")) $b18d7d2eab6a6ad8$var$dismissSettingsPanel();
}
$6KOho(document).ready(function() {
    window.status = "mapbox-ready";
    setTimeout(()=>{
        $6KOho(".anim-wrapper").removeClass("hidden");
        $6KOho(".loading-wrapper").remove();
    }, "500");
});
// Input listeners
$6KOho("input.form-control").on("input", function() {
    const posterLabel = this.dataset.posterLabel;
    if (!posterLabel) return;
    const inputValue = $6KOho(this).val();
    $6KOho(".js-" + posterLabel).html(inputValue);
    $6KOho('.js-clear-input[data-field-id="' + posterLabel + '"]').toggle(inputValue !== "");
});
$6KOho(".js-history-back").on("click", function() {
    history.back();
});
// Clear input fields
$6KOho(".js-clear-input").on("click", function() {
    const field = $6KOho(this).data("field-id");
    if (field === "search-list") {
        $6KOho('input.form-control[data-poster-label="search-list"]').val("").trigger("input").trigger("focus");
        $b18d7d2eab6a6ad8$var$loadStoredEvents();
        return;
    }
    $6KOho('input.form-control[data-poster-label="' + field + '"], textarea.form-control[data-poster-label="' + field + '"]').val("").trigger("input").trigger("focus");
});
// Check if field has value and show clear icon
function $b18d7d2eab6a6ad8$var$toggleClearIcons() {
    const inputFields = $6KOho("input.form-control");
    const textAreas = $6KOho("textarea.form-control");
    inputFields.each(function() {
        const inputValue = $6KOho(this).val();
        if (inputValue.trim() === "") {
            let emptyField = $6KOho(this).data("poster-label");
            $6KOho('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
        }
    });
    textAreas.each(function() {
        const inputValue = $6KOho(this).val();
        if (inputValue.trim() === "") {
            let emptyField = $6KOho(this).data("poster-label");
            $6KOho('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
        }
    });
}
// Changing poster
function $b18d7d2eab6a6ad8$var$setPosterSize(posterSize) {
    $b18d7d2eab6a6ad8$var$PosterWrapper.removeClass().addClass("map-wrapper size-" + posterSize + " " + $b18d7d2eab6a6ad8$var$PrintType);
}
// Change poster size
$6KOho(".js-size-option").on("click", function() {
    $b18d7d2eab6a6ad8$var$PosterSize = $6KOho(this).attr("data-size");
    $b18d7d2eab6a6ad8$var$setPosterSize($b18d7d2eab6a6ad8$var$PosterSize);
    $b18d7d2eab6a6ad8$var$setSizeSelection($b18d7d2eab6a6ad8$var$PosterSize);
    $b18d7d2eab6a6ad8$var$calculatePosterPrice();
});
function $b18d7d2eab6a6ad8$var$setSizeSelection(posterSize) {
    let selectedSize = $6KOho('.js-toggle-for-material[data-material="' + $b18d7d2eab6a6ad8$var$PrintType + '"] .js-size-option[data-size="' + posterSize + '"]');
    $6KOho(".js-size-option").removeClass("active");
    selectedSize.addClass("active");
    if ($b18d7d2eab6a6ad8$var$PrintType !== "paper") return;
    let framePrice = 0;
    let frameNormalPrice = 0;
    switch(posterSize){
        case "small":
            framePrice = 15;
            frameNormalPrice = 21.95;
            break;
        case "medium":
            framePrice = 20;
            frameNormalPrice = 24.95;
            break;
        case "large":
            framePrice = 35;
            frameNormalPrice = 39.95;
            break;
        default:
            framePrice = 0;
            frameNormalPrice = 0;
    }
    // If extra-large, force no frame
    if (posterSize === "extra-large") {
        $b18d7d2eab6a6ad8$var$PosterFrame = "no-frame";
        $b18d7d2eab6a6ad8$var$setFrameSelection($b18d7d2eab6a6ad8$var$PosterFrame);
        $b18d7d2eab6a6ad8$var$setPosterFrame($b18d7d2eab6a6ad8$var$PosterFrame);
        $6KOho(".js-frame-option").addClass("disabled");
        $6KOho('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
        $6KOho("small[frame-normal-price]").text("-");
        $6KOho("small[frame-price]").hide();
    } else {
        $6KOho(".js-frame-option").removeClass("disabled");
        $6KOho("small[frame-price]").show();
        $6KOho("small[frame-price]").text($b18d7d2eab6a6ad8$var$formatCurrency(framePrice));
        $6KOho("small[frame-normal-price]").text($b18d7d2eab6a6ad8$var$formatCurrency(frameNormalPrice));
        $6KOho(".js-frame-option").not('[data-frame="no-frame"]').attr("data-price", framePrice.toFixed(2));
    }
}
// Change print type
$6KOho(document).on("click", ".js-print-option", function() {
    let SelectedPrintType = $6KOho(this).attr("data-print");
    if ($b18d7d2eab6a6ad8$var$PrintType !== SelectedPrintType) {
        $b18d7d2eab6a6ad8$var$PrintType = SelectedPrintType;
        $b18d7d2eab6a6ad8$var$setPrintType($b18d7d2eab6a6ad8$var$PrintType);
    }
    if ($6KOho(this).hasClass("d-block")) $b18d7d2eab6a6ad8$var$PrintTypeSelected = true;
    $b18d7d2eab6a6ad8$var$togglePrintTypes();
});
$6KOho(document).on("click", ".js-show-print-types", function() {
    $b18d7d2eab6a6ad8$var$togglePrintTypes();
});
function $b18d7d2eab6a6ad8$var$setPrintType(PrintType) {
    var selectedPrint = $6KOho('.js-print-option[data-print="' + PrintType + '"]');
    $6KOho(".js-print-option").removeClass("active");
    selectedPrint.addClass("active");
    // If acryl
    if (PrintType == "acryl") {
        if ($b18d7d2eab6a6ad8$var$PosterSize === "large" || $b18d7d2eab6a6ad8$var$PosterSize === "extra-large") $b18d7d2eab6a6ad8$var$PosterSize = "small";
        $b18d7d2eab6a6ad8$var$PosterFrame = "no-frame";
    // If aluminium
    } else if (PrintType == "aluminium") {
        if ($b18d7d2eab6a6ad8$var$PosterSize === "large" || $b18d7d2eab6a6ad8$var$PosterSize === "extra-large") $b18d7d2eab6a6ad8$var$PosterSize = "medium";
        $b18d7d2eab6a6ad8$var$PosterFrame = "no-frame";
        $b18d7d2eab6a6ad8$var$setAluminiumColor($b18d7d2eab6a6ad8$var$AluminiumColor);
    // If paper
    } else {
        if ($b18d7d2eab6a6ad8$var$PosterSize === "xs") $b18d7d2eab6a6ad8$var$PosterSize = "small";
        else if ($b18d7d2eab6a6ad8$var$PosterSize === "extra-large") $b18d7d2eab6a6ad8$var$PosterSize = "large";
        $b18d7d2eab6a6ad8$var$AcrylBlock = "no-block";
    }
    $b18d7d2eab6a6ad8$var$setAcrylBlock($b18d7d2eab6a6ad8$var$AcrylBlock);
    $b18d7d2eab6a6ad8$var$setBlockSelection($b18d7d2eab6a6ad8$var$AcrylBlock);
    $b18d7d2eab6a6ad8$var$setFrameSelection($b18d7d2eab6a6ad8$var$PosterFrame);
    $b18d7d2eab6a6ad8$var$setPosterFrame($b18d7d2eab6a6ad8$var$PosterFrame);
    $b18d7d2eab6a6ad8$var$setPosterSize($b18d7d2eab6a6ad8$var$PosterSize);
    $b18d7d2eab6a6ad8$var$setSizeSelection($b18d7d2eab6a6ad8$var$PosterSize);
    $b18d7d2eab6a6ad8$var$calculatePosterPrice();
}
function $b18d7d2eab6a6ad8$var$togglePrintTypes() {
    if ($b18d7d2eab6a6ad8$var$PrintTypeSelected) {
        $6KOho(".js-print-option").hide();
        $6KOho(".js-toggle-for-material").hide();
        $6KOho(".js-show-print-types").show();
        $6KOho(".js-toggle-for-material[data-material='" + $b18d7d2eab6a6ad8$var$PrintType + "']").show();
        $6KOho(".js-print-option[data-print='" + $b18d7d2eab6a6ad8$var$PrintType + "']").show();
        $b18d7d2eab6a6ad8$var$PrintTypeSelected = false;
    } else {
        $6KOho(".js-print-option").show();
        $6KOho(".js-show-print-types").hide();
        $6KOho(".js-toggle-for-material").hide();
        $b18d7d2eab6a6ad8$var$PrintTypeSelected = true;
    }
}
// Change aluminium color
$6KOho(".js-color-option").on("click", function() {
    $b18d7d2eab6a6ad8$var$AluminiumColor = $6KOho(this).attr("data-color");
    $b18d7d2eab6a6ad8$var$setAluminiumColor($b18d7d2eab6a6ad8$var$AluminiumColor);
    $b18d7d2eab6a6ad8$var$setAluminiumColorSelection($b18d7d2eab6a6ad8$var$AluminiumColor);
});
function $b18d7d2eab6a6ad8$var$setAluminiumColor(color) {
    $b18d7d2eab6a6ad8$var$PosterWrapper.attr("data-aluminium-color", color);
}
function $b18d7d2eab6a6ad8$var$setAluminiumColorSelection(color) {
    var selectedColor = $6KOho('.js-color-option[data-color="' + color + '"]');
    $6KOho(".js-color-option").removeClass("active");
    selectedColor.addClass("active");
}
// Change acryl block
$6KOho(".js-block-option").on("click", function() {
    $b18d7d2eab6a6ad8$var$AcrylBlock = $6KOho(this).attr("data-block");
    $b18d7d2eab6a6ad8$var$setBlockSelection($b18d7d2eab6a6ad8$var$AcrylBlock);
    $b18d7d2eab6a6ad8$var$setAcrylBlock($b18d7d2eab6a6ad8$var$AcrylBlock);
    $b18d7d2eab6a6ad8$var$calculatePosterPrice();
});
function $b18d7d2eab6a6ad8$var$setBlockSelection(AcrylBlock) {
    var selectedBlock = $6KOho('.js-block-option[data-block="' + AcrylBlock + '"]');
    $6KOho(".js-block-option").removeClass("active");
    selectedBlock.addClass("active");
}
function $b18d7d2eab6a6ad8$var$setAcrylBlock(AcrylBlock) {
    $6KOho(".aluminium-stand").hide();
    $6KOho(".acryl-block").show();
    $b18d7d2eab6a6ad8$var$PosterWrapper.attr("data-perspective", false);
    if (AcrylBlock == "black") {
        $6KOho(".acryl-block").removeClass("d-none oak").addClass("black");
        $b18d7d2eab6a6ad8$var$PosterWrapper.attr("data-perspective", true);
    } else if (AcrylBlock == "oak") {
        $6KOho(".acryl-block").removeClass("d-none black").addClass("oak");
        $b18d7d2eab6a6ad8$var$PosterWrapper.attr("data-perspective", true);
    } else $6KOho(".acryl-block").removeClass("oak black").addClass("d-none");
}
// Change poster frame
$6KOho(".js-frame-option").on("click", function() {
    $b18d7d2eab6a6ad8$var$PosterFrame = $6KOho(this).attr("data-frame");
    $b18d7d2eab6a6ad8$var$setFrameSelection($b18d7d2eab6a6ad8$var$PosterFrame);
    $b18d7d2eab6a6ad8$var$setPosterFrame($b18d7d2eab6a6ad8$var$PosterFrame);
    $b18d7d2eab6a6ad8$var$activateGiftwrap();
    $b18d7d2eab6a6ad8$var$calculatePosterPrice();
});
function $b18d7d2eab6a6ad8$var$setPosterFrame(PosterFrame) {
    const frameElement = $6KOho(".poster-frame");
    const frameClasses = [
        "black-frame",
        "oak-frame",
        "white-frame"
    ];
    frameElement.removeClass(frameClasses.join(" ") + " d-none");
    if (frameClasses.includes(PosterFrame + "-frame")) frameElement.addClass(PosterFrame + "-frame");
    else frameElement.addClass("d-none");
    $b18d7d2eab6a6ad8$var$activateGiftwrap();
}
function $b18d7d2eab6a6ad8$var$setFrameSelection(frame) {
    var selectedFrame = $6KOho('.js-frame-option[data-frame="' + frame + '"]');
    $6KOho(".js-frame-option").removeClass("active");
    selectedFrame.addClass("active");
}
// Toggle giftwrap
$6KOho(".js-giftwrap").on("change", function() {
    $b18d7d2eab6a6ad8$var$calculatePosterPrice();
});
function $b18d7d2eab6a6ad8$var$activateGiftwrap() {
    if ($b18d7d2eab6a6ad8$var$PrintType === "paper" && $b18d7d2eab6a6ad8$var$PosterFrame === "no-frame") {
        $b18d7d2eab6a6ad8$var$PosterGiftwrapSelect.val("false");
        $6KOho(".js-giftwrap option[value=true]").attr("disabled", "disabled").siblings().removeAttr("disabled");
    } else $6KOho(".js-giftwrap option[value=true]").removeAttr("disabled");
}
// Change giftcard text
$6KOho(".js-giftcard").on("change", function() {
    if ($6KOho(this).val() === "true") {
        $6KOho(".js-giftcard-text").show();
        $b18d7d2eab6a6ad8$var$GiftCardText = $6KOho(".js-giftcard-text").val();
    } else {
        $6KOho(".js-giftcard-text").hide();
        $b18d7d2eab6a6ad8$var$GiftCardText = "";
    }
    $b18d7d2eab6a6ad8$var$calculatePosterPrice();
});
$6KOho(".js-giftcard-text").on("change", function() {
    $b18d7d2eab6a6ad8$var$GiftCardText = $6KOho(this).val();
});
// Get list of divisions
function $b18d7d2eab6a6ad8$var$loadDivisions() {
    $b18d7d2eab6a6ad8$var$DivisionsSelector.append(`<option value="" disabled>${$b18d7d2eab6a6ad8$var$t("hyrox.event.division")}</option>`);
    (0, (/*@__PURE__*/$parcel$interopDefault($cbb38b46c9e48450$exports))).divisions.forEach((division)=>{
        $b18d7d2eab6a6ad8$var$DivisionsSelector.append(`<option value="${division.division}">${division.division}</option>`);
    });
}
$b18d7d2eab6a6ad8$var$DivisionsSelector.on("change", function() {
    $b18d7d2eab6a6ad8$var$Division = $6KOho(this).val();
    $b18d7d2eab6a6ad8$var$DivisionLabel.html($b18d7d2eab6a6ad8$var$Division);
    $b18d7d2eab6a6ad8$var$loadAgeGroups($b18d7d2eab6a6ad8$var$Division);
    $b18d7d2eab6a6ad8$var$AgeGroupSelector.val($b18d7d2eab6a6ad8$var$AgeGroup);
});
// Get list of age groups
function $b18d7d2eab6a6ad8$var$loadAgeGroups(Division) {
    $b18d7d2eab6a6ad8$var$AgeGroupSelector.children().remove().end();
    const ageGroups = (0, (/*@__PURE__*/$parcel$interopDefault($cbb38b46c9e48450$exports)))["age-groups"][0][Division];
    $b18d7d2eab6a6ad8$var$AgeGroupSelector.append(`<option value="" disabled>${$b18d7d2eab6a6ad8$var$t("hyrox.event.ageGroup")}</option>`);
    ageGroups.forEach((ageGroup)=>{
        $b18d7d2eab6a6ad8$var$AgeGroupSelector.append(`<option value="${ageGroup.group}">${ageGroup.group}</option>`);
    });
}
$b18d7d2eab6a6ad8$var$AgeGroupSelector.on("change", function() {
    $b18d7d2eab6a6ad8$var$AgeGroup = $6KOho(this).val();
    $b18d7d2eab6a6ad8$var$AgeGroupLabel.html($b18d7d2eab6a6ad8$var$AgeGroup);
});
// Get list of stored routes
function $b18d7d2eab6a6ad8$var$loadStoredEvents() {
    $b18d7d2eab6a6ad8$var$eventsList.html("");
    (0, (/*@__PURE__*/$parcel$interopDefault($cbb38b46c9e48450$exports))).events.sort((a, b)=>a.timestamp - b.timestamp);
    (0, (/*@__PURE__*/$parcel$interopDefault($cbb38b46c9e48450$exports))).events.reverse().forEach((event)=>{
        $b18d7d2eab6a6ad8$var$eventsList.append(`<div class="col"><div class="card h-100 cursor-pointer js-load-pred-event" data-event-id="${event.id}"><div class="img-wrap"><div class="badge badge-info">${event.short}</div><img src="${event.imgUrl}" class="card-img-top" alt="..."></div><div class="card-body"><h6 class="card-title">HYROX ${event.location}</h6><small class="mb-0">${event.date}</small></div></div></div>`);
    });
    $b18d7d2eab6a6ad8$var$initEventsList();
}
function $b18d7d2eab6a6ad8$var$initEventsList() {
    $6KOho(".js-load-pred-event").on("click", function() {
        $b18d7d2eab6a6ad8$var$loadStoredEvent($6KOho(this).data("event-id"));
        $b18d7d2eab6a6ad8$var$EventsModal.hide();
        setTimeout(()=>{
            $b18d7d2eab6a6ad8$var$dismissSettingsPanel();
        }, 500);
    });
}
function $b18d7d2eab6a6ad8$var$loadStoredEvent(eventID) {
    const event = (0, (/*@__PURE__*/$parcel$interopDefault($cbb38b46c9e48450$exports))).events.find((item)=>item.id === eventID);
    if (!event) return;
    $b18d7d2eab6a6ad8$var$LocationLabel.html(event.location);
    $b18d7d2eab6a6ad8$var$LocationInput.val(event.location);
    $b18d7d2eab6a6ad8$var$ShortLabel.html(event.short);
    $b18d7d2eab6a6ad8$var$ShortInput.val(event.short);
    $b18d7d2eab6a6ad8$var$DateLabel.html(event.date);
    $b18d7d2eab6a6ad8$var$DateInput.val(event.date);
}
$6KOho(".js-init-events").on("click", function() {
    if (!$b18d7d2eab6a6ad8$var$EventsInitialized) {
        $b18d7d2eab6a6ad8$var$loadStoredEvents();
        $b18d7d2eab6a6ad8$var$EventsInitialized = true;
    }
});
// For searching the events list
$6KOho("input.js-search-event").on("input", function(e) {
    $b18d7d2eab6a6ad8$var$handleSearch($6KOho(this).val());
    if ($6KOho(this).val() === "") $6KOho('.js-clear-input[data-field-id="search-list"]').hide();
    else $6KOho('.js-clear-input[data-field-id="search-list"]').show();
});
$6KOho("input.js-search-event").on("change", function(e) {
    $b18d7d2eab6a6ad8$var$handleSearch($6KOho(this).val());
});
function $b18d7d2eab6a6ad8$var$handleSearch(inputVal) {
    let match = $b18d7d2eab6a6ad8$var$searchEvents(inputVal);
    $b18d7d2eab6a6ad8$var$eventsList.html("");
    if (match.length !== 0) {
        match.forEach((event)=>{
            $b18d7d2eab6a6ad8$var$eventsList.append(`<div class="col"><div class="card h-100 cursor-pointer js-load-pred-event" data-event-id="${event.id}"><div class="img-wrap"><div class="badge badge-info">${event.short}</div><img src="${event.imgUrl}" class="card-img-top" alt="..."></div><div class="card-body"><h6 class="card-title">HYROX ${event.location}</h6><p class="mb-0">${event.date}</p></div></div></div>`);
        });
        $b18d7d2eab6a6ad8$var$initEventsList();
    } else $b18d7d2eab6a6ad8$var$eventsList.append(`<p class="text-center w-100">${$b18d7d2eab6a6ad8$var$t("hyrox.event.noResults")}</p>`);
}
function $b18d7d2eab6a6ad8$var$searchEvents(query) {
    // Convert the query to lowercase for case-insensitive search
    query = query.toLowerCase();
    return (0, (/*@__PURE__*/$parcel$interopDefault($cbb38b46c9e48450$exports))).events.filter((event)=>{
        const { location: location, short: short, date: date } = event;
        const searchableText = `${location} ${short} ${date}`.toLowerCase();
        return searchableText.includes(query);
    });
}
// For getting predefined route from url var
function $b18d7d2eab6a6ad8$var$getEventFromQuery() {
    const regex = new RegExp("[\\?&]eventID=([^&#]*)");
    const results = regex.exec(window.location.search);
    const routeQueryParam = results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    if (routeQueryParam !== null && routeQueryParam !== "") {
        $b18d7d2eab6a6ad8$var$loadStoredEvent(parseInt(routeQueryParam));
        $b18d7d2eab6a6ad8$var$dismissSettingsPanel();
    }
}
function $b18d7d2eab6a6ad8$var$hasEventID() {
    return window.location.href.includes("?eventID") || window.location.href.includes("&eventID");
}
// Open image
$6KOho("#photo-input").on("change", function(e) {
    var files = e.target.files;
    var done = function(url) {
        $6KOho(this).value = "";
        $b18d7d2eab6a6ad8$var$CropImage.src = url;
        if ($b18d7d2eab6a6ad8$var$cropper) $b18d7d2eab6a6ad8$var$cropper.destroy();
        $6KOho(".js-save-crop").removeClass("d-none");
        $6KOho(".js-upload-image").removeClass("btn-primary").addClass("btn-quarternary");
        $b18d7d2eab6a6ad8$var$initCropper();
    };
    var reader;
    var file;
    if (files && files.length > 0) {
        file = files[0];
        if (URL) done(URL.createObjectURL(file));
        else if (FileReader) {
            reader = new FileReader();
            reader.onload = function(e) {
                done(reader.result);
            };
            reader.readAsDataURL(file);
        }
    }
});
// Cropper
function $b18d7d2eab6a6ad8$var$initCropper() {
    $b18d7d2eab6a6ad8$var$cropper = new (0, (/*@__PURE__*/$parcel$interopDefault($avtRj)))($b18d7d2eab6a6ad8$var$CropImage, {
        dragMode: "none",
        viewMode: 1,
        aspectRatio: 1.25,
        autoCropArea: 1,
        restore: false,
        guides: true,
        center: true,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
        background: false,
        zoom (event) {
            const maxZoomRatio = 2;
            const minZoomRatio = 1;
            if (event.detail.ratio > maxZoomRatio || event.detail.ratio < minZoomRatio) event.preventDefault();
        }
    });
}
$6KOho(".js-save-crop").on("click", function() {
    var croppedCanvas;
    if ($b18d7d2eab6a6ad8$var$cropper) {
        // Crop
        croppedCanvas = $b18d7d2eab6a6ad8$var$cropper.getCroppedCanvas({
            maxWidth: 4000,
            maxHeight: 4000
        });
        $b18d7d2eab6a6ad8$var$HyroxImg = croppedCanvas.toDataURL("image/jpeg", 1);
        // Check image resolution
        // checkImageResolution(HyroxImg)
        //   .then((result) => {
        //     if (!result.isValid) {
        //       console.warn(result.warning);
        //       $(".js-resolution-alert").removeClass("d-none");
        //     } else {
        //       console.log(result.message);
        //       $(".js-resolution-alert").addClass("d-none");
        //     }
        //   })
        //   .catch((error) => {
        //     console.error("Error:", error.message);
        //   });
        // Show
        $b18d7d2eab6a6ad8$var$addImageToUI($b18d7d2eab6a6ad8$var$HyroxImg);
    }
});
function $b18d7d2eab6a6ad8$var$addImageToUI(imageURL) {
    $b18d7d2eab6a6ad8$var$HyroxImg = imageURL;
    // 1) altijd meteen renderen (URL of dataURL)
    $b18d7d2eab6a6ad8$var$ImageWrapper.find("style").remove();
    $b18d7d2eab6a6ad8$var$ImageWrapper.append(`<style>.hyrox-image::before { background-image: url(${$b18d7d2eab6a6ad8$var$HyroxImg}); }</style>`);
    // 2) alleen als het een URL is (dus NIET data:image/)
    if ($b18d7d2eab6a6ad8$var$BuilderName !== "PrintApp" && typeof $b18d7d2eab6a6ad8$var$HyroxImg === "string" && $b18d7d2eab6a6ad8$var$HyroxImg && !$b18d7d2eab6a6ad8$var$HyroxImg.startsWith("data:image/")) (async ()=>{
        try {
            const base64 = await $b18d7d2eab6a6ad8$var$convertImageToBase64($b18d7d2eab6a6ad8$var$HyroxImg);
            $b18d7d2eab6a6ad8$var$ImageWrapper.find("style").remove();
            $b18d7d2eab6a6ad8$var$ImageWrapper.append(`<style>.hyrox-image::before { background-image: url(${base64}); }</style>`);
        } catch (err) {
            console.log("Failed to convert image:", err);
        }
    })();
    $6KOho(".js-hyrox-photo").attr("src", $b18d7d2eab6a6ad8$var$HyroxImg);
}
async function $b18d7d2eab6a6ad8$var$convertImageToBase64(imageUrl) {
    try {
        const proxyUrl = `https://app.scrapingbee.com/api/v1/?api_key=${"CC1CXPB29JU1991UWJ5AG1BPKP020ZY94XRSXQXRNJFE1734P5WK73S0X3WR0SN7VYU5HF8IIG63OKYO"}&url=${encodeURIComponent(imageUrl)}&render_js=false`;
        const response = await (0, $fmRoT.default).get(proxyUrl, {
            responseType: "arraybuffer"
        });
        const base64Image = $b18d7d2eab6a6ad8$require$Buffer.from(response.data).toString("base64");
        return `data:image/png;base64,${base64Image}`;
    } catch (error) {
        console.error("Error fetching image via ScrapingBee:", error);
        throw error;
    }
}
function $b18d7d2eab6a6ad8$var$checkImageResolution(base64Image) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        // Set up the event listeners
        img.onload = ()=>{
            const { width: width, height: height } = img;
            if (width < 1000 || height < 1000) resolve({
                isValid: false,
                warning: `The image resolution is too low: ${width}x${height}px. Minimum required is 1000x1000px.`
            });
            else resolve({
                isValid: true,
                message: `The image resolution is sufficient: ${width}x${height}px.`
            });
        };
        img.onerror = ()=>{
            reject(new Error("Unable to load the image. Please check the Base64 string."));
        };
        // Set the image source to the Base64 string
        img.src = base64Image;
    });
}
// Calculate poster price
function $b18d7d2eab6a6ad8$var$calculatePosterPrice() {
    const getPrice = (selector)=>parseFloat($6KOho(selector).find(".active, :selected").attr("data-price")) || 0;
    const subtotalPrice = getPrice($b18d7d2eab6a6ad8$var$PosterSizeSelect) + getPrice($b18d7d2eab6a6ad8$var$AcrylBlockSelect) + getPrice($b18d7d2eab6a6ad8$var$PosterFrameSelect) + getPrice($b18d7d2eab6a6ad8$var$PosterGiftwrapSelect) + getPrice($b18d7d2eab6a6ad8$var$GiftCardSelect);
    $6KOho(".subtotal").html($b18d7d2eab6a6ad8$var$formatCurrency(subtotalPrice));
}
// Create poster preview image
function $b18d7d2eab6a6ad8$var$createPosterPreview() {
    $6KOho(".poster-frame, .block-wrapper").addClass("hidden");
    $6KOho(".map-wrapper").addClass("shadow-none");
    const element = document.querySelector(".poster-wrapper");
    (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(element, {
        scale: window.devicePixelRatio || 2,
        useCORS: true,
        backgroundColor: "#ffffff"
    }).then((canvas)=>{
        $b18d7d2eab6a6ad8$var$PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
        $6KOho(".js-poster-preview").attr("src", $b18d7d2eab6a6ad8$var$PosterPreviewImage);
    });
    $6KOho(".map-wrapper").removeClass("shadow-none");
    $6KOho(".poster-frame, .block-wrapper").removeClass("hidden");
}
// For hiding some unnecessary fields on staging
function $b18d7d2eab6a6ad8$var$toggleProductionEnv() {}
// For saving design to local storage
function $b18d7d2eab6a6ad8$var$saveDesign() {
    localStorage.setItem("posterSize", $b18d7d2eab6a6ad8$var$PosterSize);
    localStorage.setItem("posterFrame", $b18d7d2eab6a6ad8$var$PosterFrame);
    localStorage.setItem("ContestantName", $b18d7d2eab6a6ad8$var$ContestantNameLabel.html());
    localStorage.setItem("HyroxLocation", $b18d7d2eab6a6ad8$var$LocationLabel.html());
    localStorage.setItem("HyroxShort", $b18d7d2eab6a6ad8$var$ShortLabel.html());
    localStorage.setItem("HyroxDivision", $b18d7d2eab6a6ad8$var$DivisionLabel.html());
    localStorage.setItem("HyroxAgeGroup", $b18d7d2eab6a6ad8$var$AgeGroupLabel.html());
    localStorage.setItem("HyroxDate", $b18d7d2eab6a6ad8$var$DateLabel.html());
    localStorage.setItem("HyroxFinishTime", $b18d7d2eab6a6ad8$var$FinishTimeLabel.html());
    localStorage.setItem("printType", $b18d7d2eab6a6ad8$var$PrintType);
    localStorage.setItem("acrylBlock", $b18d7d2eab6a6ad8$var$AcrylBlock);
    localStorage.setItem("aluminiumColor", $b18d7d2eab6a6ad8$var$AluminiumColor);
    if (typeof $b18d7d2eab6a6ad8$var$HyroxImg === "string" && $b18d7d2eab6a6ad8$var$HyroxImg && !$b18d7d2eab6a6ad8$var$HyroxImg.startsWith("data:image/")) localStorage.setItem("HyroxImg", $b18d7d2eab6a6ad8$var$HyroxImg);
}
// For getting design from local storage or parameters
function $b18d7d2eab6a6ad8$var$getSavedPoster() {
    // Prepare text labels
    if ($b18d7d2eab6a6ad8$var$BuilderName !== "PrintApp") {
        $b18d7d2eab6a6ad8$var$EventsModal = new $k4QTz.Modal(document.getElementById("events-modal"));
        // Hide error on close modal
        document.getElementById("events-modal").addEventListener("hide.bs.modal", function(event) {
            $6KOho(".js-alert-songtext").addClass("d-none");
        });
        if ($b18d7d2eab6a6ad8$var$options.get("ContestantName") !== null) var ContestantName = $b18d7d2eab6a6ad8$var$options.get("ContestantName");
        else var ContestantName = $b18d7d2eab6a6ad8$var$t("hyrox.editor.defaultName");
        if ($b18d7d2eab6a6ad8$var$options.get("HyroxLocation") !== null) var Location = $b18d7d2eab6a6ad8$var$options.get("HyroxLocation");
        else var Location = $b18d7d2eab6a6ad8$var$t("hyrox.editor.location");
        if ($b18d7d2eab6a6ad8$var$options.get("HyroxShort") !== null) var Short = $b18d7d2eab6a6ad8$var$options.get("HyroxShort");
        else var Short = "AFK";
        if ($b18d7d2eab6a6ad8$var$options.get("HyroxDivision") !== null) var Division = $b18d7d2eab6a6ad8$var$options.get("HyroxDivision");
        else var Division = "Open";
        if ($b18d7d2eab6a6ad8$var$options.get("HyroxAgeGroup") !== null) var AgeGroup = $b18d7d2eab6a6ad8$var$options.get("HyroxAgeGroup");
        else var AgeGroup = $b18d7d2eab6a6ad8$var$t("hyrox.editor.defaultAgeGroup");
        if ($b18d7d2eab6a6ad8$var$options.get("HyroxDate") !== null) var HyroxDate = $b18d7d2eab6a6ad8$var$options.get("HyroxDate");
        else var HyroxDate = $b18d7d2eab6a6ad8$var$t("hyrox.editor.date");
        if ($b18d7d2eab6a6ad8$var$options.get("HyroxFinishTime") !== null) var FinishTime = $b18d7d2eab6a6ad8$var$options.get("HyroxFinishTime");
        else var FinishTime = $b18d7d2eab6a6ad8$var$t("hyrox.editor.defaultFinishTime");
        if ($b18d7d2eab6a6ad8$var$options.get("HyroxImg") !== null) var HyroxImg = $b18d7d2eab6a6ad8$var$options.get("HyroxImg");
        else var HyroxImg = "https://ik.imagekit.io/wallable/Hyrox-events/woman-hyrox-placeholder.jpg";
    } else {
        var ContestantName = $b18d7d2eab6a6ad8$var$options.get("ContestantName");
        var Location = $b18d7d2eab6a6ad8$var$options.get("HyroxLocation");
        var Short = $b18d7d2eab6a6ad8$var$options.get("HyroxShort");
        var Division = $b18d7d2eab6a6ad8$var$options.get("HyroxDivision");
        var AgeGroup = $b18d7d2eab6a6ad8$var$options.get("HyroxAgeGroup");
        var HyroxDate = $b18d7d2eab6a6ad8$var$options.get("HyroxDate");
        var FinishTime = $b18d7d2eab6a6ad8$var$options.get("HyroxFinishTime");
        var HyroxDate = $b18d7d2eab6a6ad8$var$options.get("HyroxDate");
        var HyroxImg = $b18d7d2eab6a6ad8$var$options.get("HyroxImg");
    }
    // Set text labels
    $b18d7d2eab6a6ad8$var$ContestantNameLabel.html(ContestantName);
    $b18d7d2eab6a6ad8$var$ContestantNameInput.val(ContestantName);
    $b18d7d2eab6a6ad8$var$LocationLabel.html(Location);
    $b18d7d2eab6a6ad8$var$LocationInput.val(Location);
    $b18d7d2eab6a6ad8$var$ShortLabel.html(Short);
    $b18d7d2eab6a6ad8$var$ShortInput.val(Short);
    $b18d7d2eab6a6ad8$var$DivisionLabel.html(Division);
    $b18d7d2eab6a6ad8$var$DivisionsSelector.val(Division);
    $b18d7d2eab6a6ad8$var$DateLabel.html(HyroxDate);
    $b18d7d2eab6a6ad8$var$DateInput.val(HyroxDate);
    $b18d7d2eab6a6ad8$var$FinishTimeLabel.html(FinishTime);
    $b18d7d2eab6a6ad8$var$FinishTimeInput.val(FinishTime);
    // Set image
    $b18d7d2eab6a6ad8$var$addImageToUI(HyroxImg);
    if ($b18d7d2eab6a6ad8$var$BuilderName !== "PrintApp") {
        $b18d7d2eab6a6ad8$var$setBlockSelection($b18d7d2eab6a6ad8$var$AcrylBlock);
        $b18d7d2eab6a6ad8$var$setAcrylBlock($b18d7d2eab6a6ad8$var$AcrylBlock);
    }
    if ($b18d7d2eab6a6ad8$var$PrintType !== "acryl" && $b18d7d2eab6a6ad8$var$PrintType !== "aluminium") {
        if ($b18d7d2eab6a6ad8$var$PosterSize === "xs") $b18d7d2eab6a6ad8$var$PosterSize = "small";
        if ($b18d7d2eab6a6ad8$var$PrintType === "framed-poster" || $b18d7d2eab6a6ad8$var$PrintType === "tegel") $b18d7d2eab6a6ad8$var$PrintType = "paper";
    }
    $b18d7d2eab6a6ad8$var$setPosterSize($b18d7d2eab6a6ad8$var$PosterSize);
    $b18d7d2eab6a6ad8$var$setAluminiumColor($b18d7d2eab6a6ad8$var$AluminiumColor);
    $b18d7d2eab6a6ad8$var$setAluminiumColorSelection($b18d7d2eab6a6ad8$var$AluminiumColor);
    $6KOho(".js-toggle-for-material").hide();
    $b18d7d2eab6a6ad8$var$togglePrintTypes();
    $b18d7d2eab6a6ad8$var$PosterFrameSelect.val($b18d7d2eab6a6ad8$var$PosterFrame);
    $b18d7d2eab6a6ad8$var$PrintTypeSelect.val($b18d7d2eab6a6ad8$var$PrintType);
    $b18d7d2eab6a6ad8$var$setPrintType($b18d7d2eab6a6ad8$var$PrintType);
    $b18d7d2eab6a6ad8$var$activateGiftwrap();
    $b18d7d2eab6a6ad8$var$loadDivisions();
    $b18d7d2eab6a6ad8$var$loadAgeGroups(Division);
    $b18d7d2eab6a6ad8$var$DivisionsSelector.val(Division);
    $b18d7d2eab6a6ad8$var$AgeGroupLabel.html(AgeGroup);
    $b18d7d2eab6a6ad8$var$AgeGroupSelector.val(AgeGroup);
}
// Resize canvas
$6KOho(window).resize(function() {
    $b18d7d2eab6a6ad8$var$resizePosterWrapper();
});
function $b18d7d2eab6a6ad8$var$resizePosterWrapper() {
    (0, $6Kc1e.resizePosterPreview)();
}
window.visualViewport?.addEventListener("resize", $b18d7d2eab6a6ad8$var$resizePosterWrapper);
// Toggle settings panels
$6KOho(".js-settings-toggle").on("click", function() {
    var target = $6KOho(this).attr("data-target");
    $6KOho(".nav-link").removeClass("active");
    $6KOho(".nav-link[data-target=" + target + "]").addClass("active");
    if (target == "text" && $b18d7d2eab6a6ad8$var$SettingsPanel !== "text") {
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.text").removeClass("d-none");
        $b18d7d2eab6a6ad8$var$SettingsPanel = "text";
    } else if (target == "size" && $b18d7d2eab6a6ad8$var$SettingsPanel !== "size") {
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.size").removeClass("d-none");
        $b18d7d2eab6a6ad8$var$SettingsPanel = "size";
    } else if (target == "shop" && $b18d7d2eab6a6ad8$var$SettingsPanel !== "shop") {
        $b18d7d2eab6a6ad8$var$setPosterSummary();
        $6KOho(".settings-panel").addClass("d-none");
        $6KOho(".settings-panel.shop").removeClass("d-none");
        $6KOho(".nav-pills .nav-link").removeClass("active");
        $6KOho("#pills-shop-tab").addClass("active");
        $b18d7d2eab6a6ad8$var$SettingsPanel = "shop";
    }
    if ($b18d7d2eab6a6ad8$var$ShowMobileSettingPanel == false) {
        $6KOho(".side-nav").addClass("shown");
        $b18d7d2eab6a6ad8$var$ShowMobileSettingPanel = true;
    }
    $6KOho(".options-container").scrollTop(0);
    $b18d7d2eab6a6ad8$var$saveDesign();
});
$6KOho(".js-close-settings").on("click", function() {
    $b18d7d2eab6a6ad8$var$dismissSettingsPanel();
});
function $b18d7d2eab6a6ad8$var$dismissSettingsPanel() {
    $6KOho(".side-nav").removeClass("shown");
    $b18d7d2eab6a6ad8$var$ShowMobileSettingPanel = false;
}
// Prepping shopping cart
function $b18d7d2eab6a6ad8$var$setPosterSummary() {
    (0, $gF0Ex.getShoppingBagSummary)($b18d7d2eab6a6ad8$var$PosterSize, $b18d7d2eab6a6ad8$var$PrintType, $b18d7d2eab6a6ad8$var$PosterFrame, $b18d7d2eab6a6ad8$var$AcrylBlock, $b18d7d2eab6a6ad8$var$t);
    $6KOho(".js-shipping-date").html((0, $47G0t.getShippingDate)({
        t: $b18d7d2eab6a6ad8$var$t,
        formatDate: $b18d7d2eab6a6ad8$var$formatDate
    }));
    $b18d7d2eab6a6ad8$var$createPosterPreview();
}
function $b18d7d2eab6a6ad8$var$getProductVariation() {
    const variationKey = $b18d7d2eab6a6ad8$var$PrintType === "paper" ? `${$b18d7d2eab6a6ad8$var$PosterSize}-${$b18d7d2eab6a6ad8$var$PosterFrame}` : $b18d7d2eab6a6ad8$var$PosterSize;
    const product = (0, $gtTze.resolveCatalogProduct)($b18d7d2eab6a6ad8$var$marketContext.catalog, "hyrox", $b18d7d2eab6a6ad8$var$PrintType, variationKey);
    return {
        id: product?.id ?? null,
        variation_id: product?.variationId ?? null
    };
}
const $b18d7d2eab6a6ad8$var$handleUploadImage = async (HyroxImg)=>{
    $b18d7d2eab6a6ad8$var$savePosterButton.html($b18d7d2eab6a6ad8$var$t("hyrox.actions.savingImage")).prop("disabled", true);
    try {
        // Wait for the promise to resolve
        $b18d7d2eab6a6ad8$var$HyroxImgUrl = await (0, $8UUYp.uploadImage)(HyroxImg, "hyrox");
        if ($b18d7d2eab6a6ad8$var$HyroxImgUrl === null || $b18d7d2eab6a6ad8$var$HyroxImgUrl === undefined) {
            $b18d7d2eab6a6ad8$var$savePosterButton.html($b18d7d2eab6a6ad8$var$t("actions.addToCart")).prop("disabled", false);
            $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$b18d7d2eab6a6ad8$var$t("hyrox.errors.photoSaveFailed")}</div>`);
        } else {
            localStorage.setItem("HyroxImg", $b18d7d2eab6a6ad8$var$HyroxImgUrl);
            $b18d7d2eab6a6ad8$var$addToCart();
        }
    } catch (error) {
        console.error("Error uploading image:", error);
        $b18d7d2eab6a6ad8$var$savePosterButton.html($b18d7d2eab6a6ad8$var$t("actions.addToCart")).prop("disabled", false);
        $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$b18d7d2eab6a6ad8$var$t("hyrox.errors.photoSaveFailed")}</div>`);
    }
};
function $b18d7d2eab6a6ad8$var$isPrintApp() {
    return $6KOho("html").hasClass("PrintApp");
}
// Add poster to cart
$6KOho(".js-save-poster").on("click", function() {
    $b18d7d2eab6a6ad8$var$saveDesign();
    if (typeof $b18d7d2eab6a6ad8$var$HyroxImg === "string" && $b18d7d2eab6a6ad8$var$HyroxImg.startsWith("data:image/")) $b18d7d2eab6a6ad8$var$handleUploadImage($b18d7d2eab6a6ad8$var$HyroxImg);
    else {
        $b18d7d2eab6a6ad8$var$HyroxImgUrl = $b18d7d2eab6a6ad8$var$HyroxImg;
        $b18d7d2eab6a6ad8$var$addToCart();
    }
});
// Adding poster to cart
async function $b18d7d2eab6a6ad8$var$addToCart() {
    let ProductID = $b18d7d2eab6a6ad8$var$getProductVariation();
    $b18d7d2eab6a6ad8$var$savePosterButton.html(`${$b18d7d2eab6a6ad8$var$t("actions.savingDesign")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`).prop("disabled", true);
    let thumbnailUrl;
    try {
        thumbnailUrl = await (0, $8UUYp.uploadProductScreenshot)($b18d7d2eab6a6ad8$var$PosterPreviewImage, $b18d7d2eab6a6ad8$var$BuilderName);
    } catch (error) {
        console.error("Product screenshot kon niet worden opgeslagen", error);
        $b18d7d2eab6a6ad8$var$savePosterButton.html($b18d7d2eab6a6ad8$var$t("actions.addToCart")).prop("disabled", false);
        $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$b18d7d2eab6a6ad8$var$t("hyrox.errors.previewSaveFailed")}</div>`);
        return;
    }
    let payload = {
        "add-builder-item-to-cart": true,
        edit_url: $b18d7d2eab6a6ad8$var$woocommerceUrl + "/builder/hyrox-poster/?preview",
        thumbnail: thumbnailUrl,
        product_id: ProductID.id,
        variation_id: ProductID.variation_id,
        poster: {
            printType: $b18d7d2eab6a6ad8$var$PrintType,
            size: $b18d7d2eab6a6ad8$var$PosterSize,
            giftwrap: $b18d7d2eab6a6ad8$var$PosterGiftwrapSelect.val(),
            giftcardText: $b18d7d2eab6a6ad8$var$GiftCardText,
            ContestantName: localStorage.getItem("ContestantName"),
            HyroxLocation: localStorage.getItem("HyroxLocation"),
            HyroxShort: localStorage.getItem("HyroxShort"),
            HyroxDivision: localStorage.getItem("HyroxDivision"),
            HyroxAgeGroup: localStorage.getItem("HyroxAgeGroup"),
            HyroxDate: localStorage.getItem("HyroxDate"),
            HyroxFinishTime: localStorage.getItem("HyroxFinishTime"),
            HyroxImg: $b18d7d2eab6a6ad8$var$HyroxImgUrl,
            ...[
                "aluminium"
            ].includes($b18d7d2eab6a6ad8$var$PrintType) && {
                aluminiumColor: localStorage.getItem("aluminiumColor")
            },
            ...[
                "aluminium",
                "acryl"
            ].includes($b18d7d2eab6a6ad8$var$PrintType) && {
                acrylBlock: localStorage.getItem("acrylBlock")
            },
            ...[
                "paper"
            ].includes($b18d7d2eab6a6ad8$var$PrintType) && {
                frame: $b18d7d2eab6a6ad8$var$PosterFrame
            },
            main: "Hyrox " + localStorage.getItem("HyroxLocation"),
            subtitle: localStorage.getItem("ContestantName")
        },
        pdf: {
            type: "hyrox",
            print: $b18d7d2eab6a6ad8$var$PrintType === "paper" && $b18d7d2eab6a6ad8$var$PosterFrame !== "no-frame" ? "framed-poster" : $b18d7d2eab6a6ad8$var$PrintType
        }
    };
    // console.log("Payload: ", payload);
    let action = "add-to-cart";
    const endpoint = $b18d7d2eab6a6ad8$var$apiBase + "/wp-json/wallable/v1/" + action;
    let didRetryAsForm = false;
    const runAjax = (useFormEncoding = false)=>{
        return $6KOho.ajax({
            url: endpoint,
            type: "POST",
            timeout: 20000,
            ...useFormEncoding ? {
                data: {
                    payload: JSON.stringify(payload)
                }
            } : {
                contentType: "application/json",
                data: JSON.stringify(payload)
            },
            error: (jqXHR, textStatus, errorThrown)=>{
                if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
                    didRetryAsForm = true;
                    return runAjax(true);
                }
                console.error(jqXHR, textStatus, errorThrown);
                setTimeout(()=>{
                    if (!$6KOho(".js-notifications").find(".js-error").length) $6KOho(".js-notifications").append(`<div class="js-error alert alert-danger text-center p-2">${$b18d7d2eab6a6ad8$var$t("errors.generic")}</div>`);
                    $b18d7d2eab6a6ad8$var$debugReporter.show({
                        meta: {
                            action: action,
                            didRetryAsForm: didRetryAsForm
                        },
                        request: {
                            url: endpoint,
                            method: "POST",
                            mode: useFormEncoding ? "form" : "json",
                            origin: window.location.origin,
                            woocommerceUrl: $b18d7d2eab6a6ad8$var$woocommerceUrl,
                            online: navigator.onLine,
                            visibilityState: document.visibilityState
                        },
                        response: {
                            status: jqXHR?.status,
                            statusText: jqXHR?.statusText || textStatus,
                            thrownError: errorThrown ? String(errorThrown) : null,
                            responseText: (jqXHR?.responseText || "").slice(0, 4000)
                        }
                    });
                    $b18d7d2eab6a6ad8$var$savePosterButton.html($b18d7d2eab6a6ad8$var$t("actions.addToCart")).prop("disabled", false);
                }, 500);
            },
            success: ()=>{
                if (action === "add-to-cart") {
                    $b18d7d2eab6a6ad8$var$savePosterButton.html($b18d7d2eab6a6ad8$var$t("actions.addToCart")).prop("disabled", false);
                    window.location = $b18d7d2eab6a6ad8$var$woocommerceUrl + "/cart/";
                } else {
                    if (!$6KOho(".js-notifications").find(".js-error").length) $6KOho(".js-notifications").append(`<div class="js-success alert alert-success text-center p-2">&#x2713; ${$b18d7d2eab6a6ad8$var$t("actions.posterAdded")}</div>`);
                    $b18d7d2eab6a6ad8$var$savePosterButton.html($b18d7d2eab6a6ad8$var$t("actions.addToCart")).prop("disabled", false);
                }
            }
        });
    };
    runAjax(false);
}
// Tooltips
if (!$b18d7d2eab6a6ad8$var$isPrintApp()) {
    var $b18d7d2eab6a6ad8$var$tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var $b18d7d2eab6a6ad8$var$tooltipList = $b18d7d2eab6a6ad8$var$tooltipTriggerList.map(function(tooltipTriggerEl) {
        return new $k4QTz.Tooltip(tooltipTriggerEl);
    });
}


//# sourceMappingURL=hyrox-poster.7f730383.js.map
